const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const directionClasses = {
  up: 'reveal-up',
  down: 'reveal-down',
  left: 'reveal-left',
  right: 'reveal-right',
  none: 'reveal-none',
};

const observer =
  typeof window !== 'undefined' && 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target;
              el.classList.add('reveal-visible');
              observer.unobserve(el);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      )
    : null;

export default {
  mounted(el, binding) {
    const direction = directionClasses[binding.arg] ? binding.arg : 'up';
    const delay = binding.value && typeof binding.value === 'object' ? binding.value.delay : binding.value;

    if (prefersReducedMotion() || !observer) {
      return;
    }

    el.classList.add('reveal', directionClasses[direction]);
    if (delay) {
      el.style.transitionDelay = `${delay}ms`;
    }
    observer.observe(el);
  },
  unmounted(el) {
    if (observer) {
      observer.unobserve(el);
    }
  },
};
